export default __webpack_public_path__ + "static/camila-58b72d8c2c562490a68c3925365c2e2b.png";